// tslint:disable-next-line:max-line-length
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  AfterViewInit,
  ComponentFactory,
  ComponentFactoryResolver,
  ViewContainerRef,
  ComponentRef,
  ViewChild,
  Inject,
  PLATFORM_ID,
  Injector,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { CookieService } from "../../@core/services/cookie.service";
import { BehaviorSubject, Subscription } from "rxjs";
// Services
import { DataService } from "../../@core/services/data.service";
import { loadActivatedModule } from "../../@core/functions/load-material-activate-modules";
import { ComponentInfoModel } from "../../@core/models/site-data.model";
import { SiteModel } from "../../@core/models/builder.model";
import { ThemeService } from "../../@core/services/theme.service";
import { siteIdLocal } from "../../../assets/siteIdLocal";
import { FontsService } from "../../@core/services/fonts.service";
import { MenuItemModel } from "../../@core/models/site-material-data.model";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { BrowserService } from "../../@core/services/browser.service";
import { environment } from "src/environments/environment";
// import * as urlParse from 'url-parse';

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class HomepageComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("templateContainer", { read: ViewContainerRef }) container;
  componentRef: ComponentRef<any>;
  loading: boolean = true;
  openCookieConsent: boolean = false;
  matSnackBarRef: MatSnackBarRef<any>;
  allComponents: ComponentInfoModel[] = [];
  subscription: Subscription;
  companyName: string;
  fontFamily: string;
  siteId: string;
  isLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  comp: string;
  siteMenu: MenuItemModel[] = [];

  constructor(
    private cookieService: CookieService,
    private snackBar: MatSnackBar,
    private dataService: DataService,
    private titleService: Title,
    private metaService: Meta,
    private route: ActivatedRoute,
    private router: Router,
    private themeService: ThemeService,
    private fontsService: FontsService,
    private resolver: ComponentFactoryResolver,
    @Inject(PLATFORM_ID) private platformId,
    private injector: Injector,
    private browserService: BrowserService
  ) {
    /**
     * hostname = 'www.example.com' => hostInfos['www', 'exemple', 'com']
     * hostname = 'exemple.com' => hostInfos['exemple', 'com']
     */
    let hostInfos: string[] = [];
    let hostname = this.browserService.getLocation().hostname;
    hostInfos = this.browserService.getLocation().hostname.split(".");
    // hostname = 'localhost';
    this.initInfosForGetSite(hostInfos, hostname);
    const cookieConsent = this.cookieService.get("cookieConsent");
    if (!cookieConsent) {
      this.openCookieConsent = true;
    }
  }

  ngOnInit(): void {
    this.subscription = this.isLoaded$.subscribe(async (isLoaded) => {
      if (isLoaded) {
        let site = this.dataService.site$.getValue();
        if (isPlatformBrowser(this.platformId)) {
          if (site.favIcon && site.favIcon.dataUrl) {
            var link = document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = site.favIcon.dataUrl;
            document.getElementsByTagName('head')[0].appendChild(link);
          } else {
            var link = document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = './favicon.png';
            document.getElementsByTagName('head')[0].appendChild(link);
          }
          this.titleService.setTitle(site.siteName);
        }
        this.loadMetaTags(site);
        loadActivatedModule(
          site.modules,
          typeof site.siteData == "string"
            ? JSON.parse(site.siteData)
            : site.siteData,
          true
        ).then((allComponents) => {
          this.allComponents = allComponents;
          this.siteMenu = site.siteMenu;
          for (let i = 0; i < this.allComponents.length; i++) {
            this.useComponent(
              this.allComponents[i].name,
              this.allComponents[i].input,
              i
            );
          }
          this.loading = false;
        });
      }
    });
  }

  initInfosForGetSite(hostInfos, hostname) {
    const siteId = this.route.snapshot.params.siteId
      ? this.route.snapshot.params.siteId
      : "";
    if (this.dataService.siteId$.getValue()) {
      this.isLoaded$.next(true);
    } else if (siteId) {
      this.dataService.setSiteId(siteId);
      this.getSiteData({ query: siteId, type: "siteId" });
    } else if (hostname === "localhost") {
      this.dataService.setSiteId(siteIdLocal);
      this.getSiteData({ query: siteIdLocal, type: "siteIdLocal" });
    } else if (hostInfos.length === 3 && (hostname.includes('sitecreator.io') || hostname.includes('sitecreatortest.com'))) {
      const currentDomain =
        hostname.indexOf("sitecreator.io") !== -1
          ? "sitecreator"
          : "sitecreatortest";
      if (hostInfos[0] === "www" && hostInfos[1] === currentDomain) {
        // link: www.sitecreator.io
        const host: string = hostInfos[1] + "." + hostInfos[2];
        this.getSiteData({ query: host, type: "domainName" });
      } else if (hostInfos[0] !== "www" && hostInfos[1] === currentDomain) {
        // link: subdomain.sitecretor.io
        const siteUrl: string = hostInfos[0];
        this.getSiteData({ query: siteUrl, type: "siteUrl" });
      } else if (hostInfos[0] === "www" && hostInfos[1] !== currentDomain) {
        // link: www.domainname.com
        const host: string = hostInfos[1] + "." + hostInfos[2];
        this.getSiteData({ query: host, type: "domainName" });
      }
    } else if (hostInfos.length === 3 && !hostname.includes('sitecreator.io') && !hostname.includes('sitecreatortest.com')) {
      const host: string = hostInfos[0] + '.' + hostInfos[1] + '.' + hostInfos[2];
      this.getSiteData({ query: host, type: 'domainName' });
    } else if (hostInfos.length === 4) {
      if (hostInfos[0] === 'www') {
        // link: domainname.co.com
        const host: string = hostInfos[1] + '.' + hostInfos[2] + '.' + hostInfos[3];
        this.getSiteData({ query: host, type: 'domainName' });
      } else if (hostInfos[0] !== 'www') {
        // link: domainname.co.com
        const host: string = hostInfos[0] + '.' + hostInfos[1] + '.' + hostInfos[2] + '.' + hostInfos[3];
        this.getSiteData({ query: host, type: 'domainName' });
      } else {
        // link: domainname.co.com
        const host: string = hostInfos[1] + '.' + hostInfos[2] + '.' + hostInfos[3];
        this.getSiteData({ query: host, type: 'domainName' });
      }
    } else {
      const currentDomain =
        hostname.indexOf("sitecreator.io") !== -1
          ? "sitecreator"
          : "sitecreatortest";
      if (hostInfos[0] === currentDomain) {
        // link: sitecreator.io
        const host: string = hostInfos[0] + "." + hostInfos[1];
        // this.dataService.setSiteDomain({query: host, type: 'domainName'});
        this.getSiteData({ query: host, type: "domainName" });
      } else if (hostInfos[0] !== currentDomain) {
        // link: domainname.com
        const host: string = hostInfos[0] + "." + hostInfos[1];
        // this.dataService.setSiteDomain({query: host, type: 'domainName'});
        this.getSiteData({ query: host, type: "domainName" });
      } else {
        this.router.navigate(["error", 404]);
      }
    }
  }

  async getSiteData(siteInfo: { query: string; type: string }) {
    if (siteInfo.type === "siteId") {
      // tslint:disable-next-line:max-line-length
      this.subscription = this.dataService
        .getDraftSite(siteInfo.query)
        .subscribe(async (site: SiteModel) => {
          if (site !== null && Object.keys(site).length !== 0) {
            if (isPlatformBrowser(this.platformId)) {
              this.titleService.setTitle(site.siteName);
            }
            this.dataService.setSiteId(site.siteId);
            this.dataService.setSite(site);
            this.siteMenu = site.siteMenu ? site.siteMenu : [];
            if (isPlatformBrowser(this.platformId)) {
              this.themeService.updateTheme(
                typeof site.siteStyle == "string"
                  ? JSON.parse(site.siteStyle)
                  : site.siteStyle
              );
              if (site.fontFamily != "Roboto")
                this.fontsService.changeFont(site.fontFamily);
            }
            this.dataService.instagram$.next(site.instagramToken);
            this.isLoaded$.next(true);
          } else {
            this.router.navigate(["error", 404]);
          }
        });
    } else if (
      siteInfo.type === "siteUrl" ||
      siteInfo.type === "domainName" ||
      siteInfo.type === "siteIdLocal"
    ) {
      const getSiteByRouteToObservable = await this.dataService.getSiteByRoute(siteInfo);
      if (getSiteByRouteToObservable) {
        this.subscription = getSiteByRouteToObservable.subscribe((site: SiteModel) => {
          if (site && !site.siteId) {
            this.router.navigate(["error", 404]);
          }
          if (Object.keys(site).length > 0 && site.siteData) {
            site.siteData = site.siteData.replace(/\"\/assets\/img/g, '"https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img');
            site.siteData = site.siteData.replace(/\"\/assets\/screenshots-components/g, '"https://s3.amazonaws.com/ai-images.sitecreator.io/assets/screenshots-components');
            site.siteData = site.siteData.replace(/\"\/assets\/vd/g, '"https://s3.amazonaws.com/ai-images.sitecreator.io/assets/vd');
          }
          if(site && site.siteData){
            let temp = JSON.parse(site.siteData);
            let ImageGallery;
            if (temp.ImageGallery) {
              ImageGallery = temp.ImageGallery;
              delete temp.ImageGallery;
            }
            temp = JSON.stringify(temp)
            let reg = /https:\/\/dev-sitecreator-v1-serverless-s3-gallery-bucket.s3.amazonaws.com/g;
            temp = temp.replace(reg, environment.cloudFrontGalleryLinkDev)
            reg = /https:\/\/prod-sitecreator-v1-serverless-s3-gallery-bucket.s3.amazonaws.com/g;
            site.siteData = temp.replace(reg, environment.cloudFrontGalleryLinkProd)
            reg = /https:\/\/s3.amazonaws.com\/ai-images.sitecreator.io/g;
            site.siteData = temp.replace(reg, environment.aiFrontGalleryLink)
            if (ImageGallery) {
              temp = JSON.parse(site.siteData);
              temp['ImageGallery'] = ImageGallery;
              site.siteData = JSON.stringify(temp);
            }
          }
          if (site !== null && Object.keys(site).length !== 0) {
            if (isPlatformBrowser(this.platformId)) {
              this.titleService.setTitle(site.siteName);
            }
            this.dataService.setSiteId(site.siteId);
            if (isPlatformBrowser(this.platformId)) {
              if (site.fontFamily != "Roboto")
                this.fontsService.changeFont(site.fontFamily);
            }
            this.dataService.setSite(site);
            this.dataService.instagram$.next(site.instagramToken);
            this.isLoaded$.next(true);
          } else {
            this.router.navigate(["error", 404]);
          }
        }, err => {
        });
      }
    }
  }

  // Load view chiled component and inject data
  useComponent(component, input, position): void {
    const factory: ComponentFactory<any> =
      this.resolver.resolveComponentFactory(component);
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.data = input;
    this.componentRef.instance.active = false;
    this.componentRef.instance.position = position;
    if (this.siteMenu && this.siteMenu.length > 0) {
      this.componentRef.instance.activatePadding =
        position == 1 && this.siteMenu[0].transparentHeader ? true : false;
    } else {
      this.componentRef.instance.activatePadding = false;
    }
  }

  ngAfterViewInit() { }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeSnackBar(): void {
    const monthInMs = 1000 * 60 * 60 * 24 * 30;
    this.cookieService.setWithExpiryInMiliseconds(
      "cookieConsent",
      "true",
      monthInMs
    );
    this.openCookieConsent = false;
  }

  isEven(n) {
    return n % 2 === 0;
  }
  loadMetaTags(site: SiteModel) {
    this.metaService.updateTag({ property: 'og:description', content: site.description });
    this.metaService.updateTag({ property: 'og:url', content: site.domainName ? site.domainName : site.siteUrl });
    this.metaService.updateTag({ property: 'og:height', content: "628" });
    this.metaService.updateTag({ property: 'og:width', content: "1200" });
    this.metaService.updateTag({ property: 'og:type', content: "website" });
    this.metaService.updateTag({ property: 'og:site_name', content: site.siteName });
    this.metaService.updateTag({ property: 'og:title', content: site.siteName });
    this.metaService.updateTag({ property: 'og:author', content: site.siteName });
    this.metaService.updateTag({ name: 'twitter:title', content: site.siteName });
    this.metaService.updateTag({ name: 'twitter:image:alt', content: site.siteName });
    this.metaService.updateTag({ name: 'twitter:creator', content: site.siteName });
    this.metaService.updateTag({ name: 'twitter:description', content: site.description });
    this.metaService.updateTag({ property: 'twitter:site', content: site.domainName ? site.domainName : site.siteUrl });
    this.metaService.updateTag({ name: 'title', content: site.siteName });
    this.metaService.addTags([
      {
        name: 'keywords',
        content: site.keywords,
      },
      { name: 'robots', content: 'index, follow' },
      { name: 'description', content: site.description },
      { name: 'author', content: site.siteName },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' },
    ]);

    if (site.metaImage) {
      this.metaService.updateTag({ property: 'og:image', content: site.metaImage.image });
      this.metaService.updateTag({ property: 'og:image:width', content: '1200' });
      this.metaService.updateTag({ property: 'og:image:height', content: '628' });
      this.metaService.updateTag({ property: 'og:image:alt', content: site.siteName });
      this.metaService.updateTag({ name: 'twitter:image', content: site.metaImage.image });
      this.metaService.updateTag({ name: 'twitter:card', content: site.metaImage.image });
    } else {
      let BreakException = {};
      let imageBackground;
      try {
        const sitedata = typeof site.siteData == 'string' ? JSON.parse(site.siteData) : site.siteData;
        Object.keys(sitedata).forEach((value, key) => {
          if (['HeroBackgroundImage', 'HeroImage', 'HeroBackgroundImage'].includes(value)) {
            imageBackground = sitedata[value][0].image;
            throw BreakException;
          }
          if (['FeaturesRow'].includes(value)) {
            imageBackground = sitedata[value][0].features[0].image;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      this.metaService.updateTag({ property: 'og:image', content: imageBackground });
      this.metaService.updateTag({ property: 'og:image:width', content: '1200' });
      this.metaService.updateTag({ property: 'og:image:height', content: '628' });
      this.metaService.updateTag({ property: 'og:image:alt', content: site.siteName });
      this.metaService.updateTag({ name: 'twitter:image', content: imageBackground });
      this.metaService.updateTag({ name: 'twitter:card', content: imageBackground });
    }
  }
}
